import React, { useEffect, useState } from 'react';
import { array, func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import { get, isEmpty, isNil, isString } from 'lodash';

import FormControl from '@material-ui/core/FormControl';

import AutoComplete from '../../../components/FormFields/Autocomplete';
import ConfirmButton from '../../../components/ConfirmButton';

import AddClientContactModal from '../../Modals/AddClientContactModal';

import * as ArchitectActions from '../../../actions/architectActions';
import * as ContactActions from '../../../actions/contactActions';
import * as ServiceManagementActions from '../../../actions/serviceManagementActions';
import * as SiteActions from '../../../actions/siteActions';

import classes from './CallInformation.module.css';

const CallInformation = ({
    activeItem,
    areasList,
    callPriorities,
    callStatus,
    callStatuses,
    clientContacts,
    clientsList,
    contactsList,
    equipmentAndSystemList,
    fetchClientContacts,
    fetchInitialAreas,
    fetchInitialContacts,
    fetchInitialEquipmentAndSystems,
    fetchInitialSites,
    fetchSiteContacts,
    priority,
    resetContacts,
    resetLists,
    resetSites,
    setCallStatus,
    setPriority,
    setSMArea,
    setSMClient,
    setSMContact,
    setSMEquipmentOrSystem,
    setSMSite,
    siteContacts,
    sitesList,
    targetArea,
    targetEquipmentOrSystem,
    targetClient,
    targetContact,
    targetSite,
    ...props
}) => {

    const [addClientContactModalOpen, setAddClientContactModalOpen] = useState(false);

    const [siteContactList, setSiteContactList] = useState([]);

    useEffect(() => {
        if (!isEmpty(siteContacts)) {
            siteContacts.forEach(item => {
                item.name = `${item.userName.FirstName} ${item.userName.LastName}`;
            });

            const payload = [
                {
                    items:     [...siteContacts].sort(_sorter),
                    name:      'Contacts',
                    itemProps: {
                        type: 'contacts'
                    }
                }
            ];

            setSiteContactList(payload);
        }

    }, [siteContacts]);

    useEffect(() => {
        const status = get(activeItem, 'status', '');
        const priority = get(activeItem, 'priority', '');

        isString(status) ? setCallStatus(status) : setCallStatus('');
        isString(priority) ? setPriority(priority) : setPriority('');

        const siteId = get(activeItem, 'relatedSite.id', '');

        setSMArea(get(activeItem, 'relatedArea.id', ''));
        setSMClient(get(activeItem, 'relatedClient.id', ''));
        setSMContact(get(activeItem, 'clientContactId', ''));
        setSMSite(siteId);

        const equipmentId = get(activeItem, 'relatedEquipment.id', '');
        const systemId = get(activeItem, 'relatedSystem.id', '');

        if (equipmentId && siteId) {
            setSMEquipmentOrSystem(equipmentId, 'equipment');
        } else if (systemId && siteId) {
            setSMEquipmentOrSystem(systemId, 'system');
        } else {
            setSMEquipmentOrSystem();
        }

    }, [activeItem]);

    const disableCreateContactButton = ({ id }) => {
        return !isEmpty(id);
    };

    const handleCallStatus = event => {
        const {value} = event.target;

        if (isNil(value) || isEmpty(value)) {
            setCallStatus('');

            return;
        }

        const name = value.name || value.label;

        setCallStatus(name);
    };

    const handleCallStatusBlur = event => {
        const {value} = event.target;

        if (isNil(value) || isEmpty(value)) {
            setCallStatus('');
        }
    };

    const handlePriority = event => {
        const {value} = event.target;

        if (isNil(value) || isEmpty(value)) {
            setPriority('');

            return;
        }

        setPriority(value.name);
    };

    const handlePriorityBlur = event => {
        const {value} = event.target;

        if (isNil(value) || isEmpty(value)) {
            setPriority('');
        }
    };

    const handleClient = async event => {
        const {value} = event.target;

        if (isNil(value) || isEmpty(value)) {
            resetContacts();
            resetSites();
            resetLists();

            setSMClient('');
            setSMArea('');
            setSMContact('');
            setSMSite('');
            setSMEquipmentOrSystem('');

            return;
        }

        if (value.id === targetClient.id) {
            setSMClient(value.id);

            return;
        }

        fetchInitialSites(value.id);

        if (!process.env.contactsEnabled) {
            fetchInitialContacts(value.id);
        }

        resetLists();

        setSMClient(value.id);
        setSMArea('');
        setSMContact('');
        setSMSite('');
        setSMEquipmentOrSystem('');
    };

    const handleSite = async event => {
        const {value} = event.target;

        if (isNil(value) || isEmpty(value)) {
            resetLists();

            setSMSite('');
            setSMArea('');
            setSMEquipmentOrSystem('');

            return;
        }

        if (value.id === targetSite.id) {
            setSMSite(value.id);

            return;
        }

        if (process.env.contactsEnabled) {
            await fetchSiteContacts(targetClient.id, value.id);
        }

        fetchInitialAreas(value.id);
        fetchInitialEquipmentAndSystems(value.id);

        setSMSite(value.id);
        setSMArea('');
        setSMEquipmentOrSystem('');
    };

    const handleEquipmentOrSystem = event => {
        const {value} = event.target;

        if (isNil(value) || isEmpty(value)) return;

        if (value.type === 'equipment') {
            setSMEquipmentOrSystem(value.id, 'equipment');
        } else if (value.type === 'systems') {
            setSMEquipmentOrSystem(value.id, 'system');
        }
    };

    const handleArea = event => {
        const {value} = event.target;

        if (isNil(value) || isEmpty(value)) {
            setSMArea('');

            return;
        }

        setSMArea(value.id);
    };

    const handleContact = event => {
        const {value} = event.target;

        if (isNil(value) || isEmpty(value)) return;

        if (process.env.contactsEnabled) {
            setSMContact(value.id);
        } else {
            setSMContact(value.id);
        }
    };

    const handleContactBlur = event => {
        const {value} = event.target;

        if (isEmpty(value)) {
            setSMContact('');
        }
    };

    const handleCreateContact = () => {
        setAddClientContactModalOpen(true);
    };

    const _sorter = (a, b) => {
        let roleA = a.name.toUpperCase();
        let roleB = b.name.toUpperCase();

        if (roleA < roleB) {
            return -1;
        }
        if (roleA > roleB) {
            return 1;
        }

        return 0;
    };

    return (
        <div className={classes.CallInformation}>
            <div className={classes.callInformationTitle}>
                Call Information
            </div>
            <div className={classes.selectContainer}>
                <FormControl className={classes.formControl}>
                    <AutoComplete
                        grouped
                        label="Call Status (Required)"
                        name="callStatus"
                        classes={{
                            inputRoot: classes.inputRoot
                        }}
                        className={classes.autoComplete}
                        onChange={handleCallStatus}
                        onBlur={handleCallStatusBlur}
                        options={callStatuses}
                        value={callStatus}
                        disabled={activeItem.locked}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <AutoComplete
                        grouped
                        label="Priority (Required)"
                        name="priority"
                        classes={{
                            inputRoot: classes.inputRoot
                        }}
                        className={classes.autoComplete}
                        onChange={handlePriority}
                        onBlur={handlePriorityBlur}
                        options={callPriorities}
                        value={priority}
                        disabled={activeItem.locked}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <AutoComplete
                        grouped
                        label="Client (Required)"
                        name="client"
                        classes={{
                            inputRoot: classes.inputRoot
                        }}
                        className={classes.autoComplete}
                        onChange={handleClient}
                        options={clientsList}
                        value={targetClient}
                        disabled={activeItem.locked}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <AutoComplete
                        grouped
                        label="Site"
                        name="site"
                        classes={{
                            inputRoot: classes.inputRoot
                        }}
                        className={classes.autoComplete}
                        onChange={handleSite}
                        options={sitesList}
                        value={targetSite}
                        disabled={activeItem.locked}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <AutoComplete
                        grouped
                        label="Equipment/System"
                        name="equipmentOrSystem"
                        classes={{
                            inputRoot: classes.inputRoot
                        }}
                        className={classes.autoComplete}
                        onChange={handleEquipmentOrSystem}
                        options={equipmentAndSystemList}
                        value={targetEquipmentOrSystem}
                        disabled={activeItem.locked}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <AutoComplete
                        grouped
                        label="Area"
                        name="area"
                        classes={{
                            inputRoot: classes.inputRoot
                        }}
                        className={classes.autoComplete}
                        onChange={handleArea}
                        options={areasList}
                        value={targetArea}
                        disabled={activeItem.locked}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <AutoComplete
                        grouped
                        label="Site Contact"
                        name="contact"
                        classes={{
                            inputRoot: classes.inputRoot
                        }}
                        className={classes.autoComplete}
                        onChange={handleContact}
                        onBlur={handleContactBlur}
                        options={process.env.contactsEnabled ? siteContactList : contactsList}
                        value={targetContact}
                        disabled={activeItem.locked}
                    />
                </FormControl>
            </div>
            <div className={classes.requestor}>
                <div className={classes.requestorLabel}>
                    Requestor Info
                </div>
                <div className={classes.requestor}>
                    <span>{activeItem.requesterName}</span>
                    <span>{activeItem.requesterPhone}</span>
                    <span>{activeItem.requesterEmail}</span>
                </div>
            </div>
            <div className={classes.createContactWrapper}>
                {
                    process.env.contactsEnabled ?
                        null
                        :
                        <ConfirmButton
                            confirm={handleCreateContact}
                            label="Add Client Contact"
                            type="button"
                            disabled={disableCreateContactButton(targetContact) || activeItem.locked}
                        />
                }
            </div>
            <AddClientContactModal
                open={addClientContactModalOpen}
                close={() => setAddClientContactModalOpen(false)}
                title="Add Client Contact"
            />
        </div>
    );
};

CallInformation.defaultProps = {
    activeItem:              {},
    areasList:               [],
    callStatus:              '',
    clientsList:             [],
    contactsList:            [],
    equipmentAndSystemList:  [],
    priority:                '',
    setCallStatus:           () => {},
    setPriority:             () => {},
    sitesList:               [],
    systemsList:             [],
    targetArea:              {},
    targetClient:            {},
    targetContact:           {},
    targetEquipmentOrSystem: {},
    targetSite:              {}
};

CallInformation.propTypes = {
    activeItem:              object,
    areasList:               array,
    callStatus:              string,
    clientsList:             array,
    contactsList:            array,
    equipmentAndSystemList:  array,
    priority:                string,
    setCallStatus:           func,
    setPriority:             func,
    sitesList:               array,
    targetArea:              object,
    targetClient:            object,
    targetContact:           object,
    targetEquipmentOrSystem: object,
    targetSite:              object
};

const mapStateToProps = state => {
    return {
        activeItem:              state.svcManagement.activeItem,
        areasList:               state.svcManagement.areasList,
        callPriorities:          state.svcManagement.callPriorities,
        callStatus:              state.svcManagement.callStatus,
        callStatuses:            state.svcManagement.callStatuses,
        clientContacts:          state.contact.clientContacts,
        clientsList:             state.svcManagement.clientsList,
        contactsList:            state.svcManagement.contactsList,
        equipmentAndSystemList:  state.svcManagement.equipmentAndSystemList,
        priority:                state.svcManagement.priority,
        siteContacts:            state.contact.siteContacts,
        sitesList:               state.svcManagement.sitesList,
        targetArea:              state.svcManagement.targetArea,
        targetEquipmentOrSystem: state.svcManagement.targetEquipmentOrSystem,
        targetClient:            state.svcManagement.targetClient,
        targetContact:           state.svcManagement.targetContact,
        targetSite:              state.svcManagement.targetSite
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ContactActions,
    ...ServiceManagementActions,
    ...SiteActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CallInformation);
